"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var b = function b(e, t) {
  return t.split(".").reduce(function (n, r) {
    return n[r];
  }, e);
};

exports.a = b;